import { useTranslation } from "react-i18next";

import { QuestionnaireFormSection } from "../shared/QuestionnaireFormSection";
import { QuestionnaireAttachmentField } from "../shared/QuestionnaireAttachmentField";
import { QuestionnaireAttachmentMeta } from "../../hooks/attachment";

interface QuestionnaireAttachmentsSectionProps {
  attachments: Record<string, QuestionnaireAttachmentMeta[]>;
  disabled?: boolean;
}

export function QuestionnaireAttachmentsSection({
  attachments,
  disabled = false,
}: QuestionnaireAttachmentsSectionProps) {
  const { t } = useTranslation();

  return (
    <QuestionnaireFormSection
      title={t("questionnaires.form.conditionalFields.attachments")}
    >
      <QuestionnaireAttachmentField
        name="attachments"
        label={t("questionnaires.form.conditionalFields.attachments")}
        existingAttachments={attachments.attachments}
        disabled={disabled}
      />
    </QuestionnaireFormSection>
  );
}
